
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta } from "/app/app/pages/login.vue?macro=true";
import { default as statusYPoQNMN5F_AVqPEGHlSUe1HZ2ZEBI1AuJsAa1WxAczIMeta } from "/app/app/pages/status.vue?macro=true";
import { default as index0SjpqFru9naX48uIimtfGu9fmflhtPPZKu7nUV18cAQMeta } from "/app/app/pages/admin/files/index.vue?macro=true";
import { default as _91_46_46_46slug_93dbBYpNwsqpCg8pL_gK0W_SabwuEMNk0Sd0xOPW0R3bAMeta } from "/app/app/pages/admin/files/[...slug].vue?macro=true";
import { default as deleted_45filespEegFlwSADojO3HywIbQn5O7lAAAlk69jLDHMsIerdMMeta } from "/app/app/pages/admin/files/deleted-files.vue?macro=true";
import { default as _91id_93iUzYyb9xwIWtk45pwmXmct7SD_az7A2uFE73_5OjT10Meta } from "/app/app/pages/admin/files/company-files/[id].vue?macro=true";
import { default as indexOGuuAwxrxcn9_qsIexz0UR9Rd_XFDoo9TXTJXt_VXm0Meta } from "/app/app/pages/admin/files/company-files/index.vue?macro=true";
import { default as deletedJU5nv3gQA7XfbyKRdjuTAR2z2yj25W3v6N0wdQ2eTNQMeta } from "/app/app/pages/admin/files/company-files/deleted.vue?macro=true";
import { default as filesT0c_taogEcWW_Xc86iy85YTly5UEHyD8BRBVu_a_hYkMeta } from "/app/app/pages/admin/files.vue?macro=true";
import { default as indexBGbi9mJzJJpiRjuRhKvga_0QspKTUlmVO0QyRz6Z3r8Meta } from "/app/app/pages/admin/index.vue?macro=true";
import { default as _91_91id_93_93wKsW6CPhx415pjKlGUvEY00jb4ZIRkBT6FRHl00rvYEMeta } from "/app/app/pages/dora/[[id]].vue?macro=true";
import { default as maintenanceB0dPhdEyV88_MoClqO_e6VO_RgGIumEnK1cdoU0zHTYMeta } from "/app/app/pages/maintenance.vue?macro=true";
import { default as profile1p4Xc5f6OExp0AK6GYmXeWMj29H22QsBfePnRhI4FZAMeta } from "/app/app/pages/user/profile.vue?macro=true";
import { default as profileoZVrqD_y4_B_x5fBJjZfJXaFwaN713_AZQ9ZsWUlmJMMeta } from "/app/app/pages/admin/profile.vue?macro=true";
import { default as meetingsuomYiUGui_TKjI_GA6AJZXmQP482hGC0E2NborVuLXoMeta } from "/app/app/pages/admin/meetings.vue?macro=true";
import { default as settingsnmfEMKet3T2n1xfJIBWt_LB8YDC_hbu0jjjgMIT7UbYMeta } from "/app/app/pages/admin/settings.vue?macro=true";
import { default as indexUPFWZZtjoQv5FoMcD2JyiskUiuyTCnZr2AtN0YtXuYcMeta } from "/app/app/pages/meetings/index.vue?macro=true";
import { default as password_45resetz80sjnC5N36WxK3DgJSBxoz73kxKH8S9I6sl7sV4sXoMeta } from "/app/app/pages/password-reset.vue?macro=true";
import { default as modelsmlVdVzbKUndl_qUPv_p_UvuotrMB55xn1dj6rD06PP0Meta } from "/app/app/pages/ai-admin/models.vue?macro=true";
import { default as forgot_45password_svvr_HXOSYgUMkqXVPpKJfwi_QEp8hjfRcKoAib3NwMeta } from "/app/app/pages/forgot-password.vue?macro=true";
import { default as _91id_93ToVdaHbF_hg8v5MbFrFrbwxmifUmCKjp9fDvyz3N1cQMeta } from "/app/app/pages/admin/decks/[id].vue?macro=true";
import { default as indexF9S7C_AMLTU4sK7nUgRGBgCViTQpCTeOmFroeqyQFZAMeta } from "/app/app/pages/admin/dora/index.vue?macro=true";
import { default as my_45companypmu_I8cHbDOoIl1ilP0yoVcjI2rR5_kfQaf_XGaAO3oMeta } from "/app/app/pages/admin/my-company.vue?macro=true";
import { default as _91id_93GQAbLMMUspOVr2_suBiRaCWDnYrQughOIMrXeDN1upsMeta } from "/app/app/pages/admin/users/[id].vue?macro=true";
import { default as _91_91id_93_93YjxEjz0JsD76XdJ43WhXcNhBiV921QHmpVpcynWSeJMMeta } from "/app/app/pages/beta/dora/[[id]].vue?macro=true";
import { default as _91id_93DRu3sc22ldfQPboBCyVv6Il6MGF_yhbkNf1O7qR4DxoMeta } from "/app/app/pages/admin/assets/[id].vue?macro=true";
import { default as indexPNINfdJS6zqSj7OdilBfOrnaPr_WhB5BGrP0LeUs1KsMeta } from "/app/app/pages/admin/decks/index.vue?macro=true";
import { default as _91id_93yMh_dbsWq3U3H1mNnqNuA6L315ig1YUCvxRqAcKITd4Meta } from "/app/app/pages/admin/embeds/[id].vue?macro=true";
import { default as indexI6uA6JeAc9EKls3McO36wY7U9LUyjNGCD0Sfkr6BKwQMeta } from "/app/app/pages/admin/users/index.vue?macro=true";
import { default as indexsxhQDjaMms9Jr4S1DtAulDAQi2As4Pp7GkkR5v5SzsIMeta } from "/app/app/pages/admin/assets/index.vue?macro=true";
import { default as indexIECdWnrHSHMBuW3Zxz1A96Bgdyj05NRo2Z2K0soHhJwMeta } from "/app/app/pages/admin/embeds/index.vue?macro=true";
import { default as indexvOqUjCI6IynWruUOT_JjSNnkoInXY0r_YKXjStTSRGEMeta } from "/app/app/pages/admin/models/index.vue?macro=true";
import { default as newHV9Q5xSE2IPsPrvuoJ_JniwPXyqw3GWFYX4AH3vFM6UMeta } from "/app/app/pages/admin/companies/new.vue?macro=true";
import { default as createhSNsztH9__duTbHuA3S_iZuB7r3IckjZjOH0qhATBMAMeta } from "/app/app/pages/admin/embeds/create.vue?macro=true";
import { default as _91deckId_93sbkipH1lufvlYKfh0T0PeiGTgnFOWK6rn_7iL5qS7csMeta } from "/app/app/pages/beta/decks/[deckId].vue?macro=true";
import { default as indexdkwa9PpVT3S3S_MTH0YkNYrrCMxo_R1Xw9bqcGP1lq0Meta } from "/app/app/pages/admin/companies/index.vue?macro=true";
import { default as _91id_93fBeAP_VN8Fz7WLu9kWWl6L7_WsNhls_m1OQgmc5trjwMeta } from "/app/app/pages/admin/recordings/[id].vue?macro=true";
import { default as index8BKTnaioCF5YwJFvJmFyu9ZqI5owA32UhfcS18_ahrEMeta } from "/app/app/pages/admin/recordings/index.vue?macro=true";
import { default as _91id_93fWnjb1BIIQXyfTWBSlUitPeczwBoPfkZTCKAD2qI9f0Meta } from "/app/app/pages/admin/embeds/video/[id].vue?macro=true";
import { default as _91_91token_93_93JMU9ETkP_F_yA_TmAiscuUnTGwOZErJGnVKlGobYPxQMeta } from "/app/app/pages/admin/activate/[[token]].vue?macro=true";
import { default as indexhxrrYWKdxVL0tc_gyhxzQSts4QH85v4gr44_IfKXys8Meta } from "/app/app/pages/admin/embeds/video/index.vue?macro=true";
import { default as _91_46_46_46slug_936zR_bNvbWaovsjMg23rK6Lr9fbiiwEbq8DpLUac__0cMeta } from "/app/app/pages/admin/validate/[...slug].vue?macro=true";
import { default as _91meetingId_93tVWv9K0BEBPi1_yhcXnNFlDf_w6K8ga9HzHlRPvDdRIMeta } from "/app/app/pages/beta/meeting/[meetingId].vue?macro=true";
import { default as _91id_93quZpT3cfZEtaecpGilCykH18QQlabMxANnXbxchn4pgMeta } from "/app/app/pages/embed/presentations/[id].vue?macro=true";
import { default as _91uuid_93Z5HWRSUxJPOe6atzGj6z0eLMyhR0MXOcMzb7EGTrwiQMeta } from "/app/app/pages/meetings/recordings/[uuid].vue?macro=true";
import { default as index1ro0dzUl73NU10HiuYjvboRohl_XeronGVEnAChmYrcMeta } from "/app/app/pages/admin/feature-processing/index.vue?macro=true";
import { default as create9B9oxUxuhn2uZQ90lcksP0UQrfGB9nDlmT8ikUGkC9MMeta } from "/app/app/pages/admin/feature-processing/create.vue?macro=true";
import { default as _91id_93XlJyzI075nmFISzf4GGl_MevAfT_loD6yO20xkL8w0sMeta } from "/app/app/pages/embed/presentations/preview/[id].vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta || {},
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "status___en",
    path: "/status",
    component: () => import("/app/app/pages/status.vue")
  },
  {
    name: filesT0c_taogEcWW_Xc86iy85YTly5UEHyD8BRBVu_a_hYkMeta?.name,
    path: "/admin/files",
    meta: filesT0c_taogEcWW_Xc86iy85YTly5UEHyD8BRBVu_a_hYkMeta || {},
    component: () => import("/app/app/pages/admin/files.vue"),
    children: [
  {
    name: "admin-files___en",
    path: "",
    meta: index0SjpqFru9naX48uIimtfGu9fmflhtPPZKu7nUV18cAQMeta || {},
    component: () => import("/app/app/pages/admin/files/index.vue")
  },
  {
    name: "admin-files-slug___en",
    path: ":slug(.*)*",
    meta: _91_46_46_46slug_93dbBYpNwsqpCg8pL_gK0W_SabwuEMNk0Sd0xOPW0R3bAMeta || {},
    component: () => import("/app/app/pages/admin/files/[...slug].vue")
  },
  {
    name: "admin-files-deleted-files___en",
    path: "deleted-files",
    meta: deleted_45filespEegFlwSADojO3HywIbQn5O7lAAAlk69jLDHMsIerdMMeta || {},
    component: () => import("/app/app/pages/admin/files/deleted-files.vue")
  },
  {
    name: "admin-files-company-files-id___en",
    path: "company-files/:id()",
    meta: _91id_93iUzYyb9xwIWtk45pwmXmct7SD_az7A2uFE73_5OjT10Meta || {},
    component: () => import("/app/app/pages/admin/files/company-files/[id].vue")
  },
  {
    name: "admin-files-company-files___en",
    path: "company-files",
    meta: indexOGuuAwxrxcn9_qsIexz0UR9Rd_XFDoo9TXTJXt_VXm0Meta || {},
    component: () => import("/app/app/pages/admin/files/company-files/index.vue")
  },
  {
    name: "admin-files-company-files-deleted___en",
    path: "company-files/deleted",
    meta: deletedJU5nv3gQA7XfbyKRdjuTAR2z2yj25W3v6N0wdQ2eTNQMeta || {},
    component: () => import("/app/app/pages/admin/files/company-files/deleted.vue")
  }
]
  },
  {
    name: "admin___en",
    path: "/admin",
    meta: indexBGbi9mJzJJpiRjuRhKvga_0QspKTUlmVO0QyRz6Z3r8Meta || {},
    component: () => import("/app/app/pages/admin/index.vue")
  },
  {
    name: "dora-id___en",
    path: "/dora/:id?",
    meta: _91_91id_93_93wKsW6CPhx415pjKlGUvEY00jb4ZIRkBT6FRHl00rvYEMeta || {},
    component: () => import("/app/app/pages/dora/[[id]].vue")
  },
  {
    name: "maintenance___en",
    path: "/maintenance",
    component: () => import("/app/app/pages/maintenance.vue")
  },
  {
    name: "user-profile___en",
    path: "/user/profile",
    component: () => import("/app/app/pages/user/profile.vue")
  },
  {
    name: "admin-profile___en",
    path: "/admin/profile",
    meta: profileoZVrqD_y4_B_x5fBJjZfJXaFwaN713_AZQ9ZsWUlmJMMeta || {},
    component: () => import("/app/app/pages/admin/profile.vue")
  },
  {
    name: "admin-meetings___en",
    path: "/admin/meetings",
    meta: meetingsuomYiUGui_TKjI_GA6AJZXmQP482hGC0E2NborVuLXoMeta || {},
    component: () => import("/app/app/pages/admin/meetings.vue")
  },
  {
    name: "admin-settings___en",
    path: "/admin/settings",
    meta: settingsnmfEMKet3T2n1xfJIBWt_LB8YDC_hbu0jjjgMIT7UbYMeta || {},
    component: () => import("/app/app/pages/admin/settings.vue")
  },
  {
    name: "meetings___en",
    path: "/meetings",
    component: () => import("/app/app/pages/meetings/index.vue")
  },
  {
    name: "password-reset___en",
    path: "/password-reset",
    component: () => import("/app/app/pages/password-reset.vue")
  },
  {
    name: "ai-admin-models___en",
    path: "/ai-admin/models",
    component: () => import("/app/app/pages/ai-admin/models.vue")
  },
  {
    name: "forgot-password___en",
    path: "/forgot-password",
    component: () => import("/app/app/pages/forgot-password.vue")
  },
  {
    name: "admin-decks-id___en",
    path: "/admin/decks/:id()",
    meta: _91id_93ToVdaHbF_hg8v5MbFrFrbwxmifUmCKjp9fDvyz3N1cQMeta || {},
    component: () => import("/app/app/pages/admin/decks/[id].vue")
  },
  {
    name: "admin-dora___en",
    path: "/admin/dora",
    meta: indexF9S7C_AMLTU4sK7nUgRGBgCViTQpCTeOmFroeqyQFZAMeta || {},
    component: () => import("/app/app/pages/admin/dora/index.vue")
  },
  {
    name: "admin-my-company___en",
    path: "/admin/my-company",
    meta: my_45companypmu_I8cHbDOoIl1ilP0yoVcjI2rR5_kfQaf_XGaAO3oMeta || {},
    component: () => import("/app/app/pages/admin/my-company.vue")
  },
  {
    name: "admin-users-id___en",
    path: "/admin/users/:id()",
    meta: _91id_93GQAbLMMUspOVr2_suBiRaCWDnYrQughOIMrXeDN1upsMeta || {},
    component: () => import("/app/app/pages/admin/users/[id].vue")
  },
  {
    name: "beta-dora-id___en",
    path: "/beta/dora/:id?",
    meta: _91_91id_93_93YjxEjz0JsD76XdJ43WhXcNhBiV921QHmpVpcynWSeJMMeta || {},
    component: () => import("/app/app/pages/beta/dora/[[id]].vue")
  },
  {
    name: "admin-assets-id___en",
    path: "/admin/assets/:id()",
    meta: _91id_93DRu3sc22ldfQPboBCyVv6Il6MGF_yhbkNf1O7qR4DxoMeta || {},
    component: () => import("/app/app/pages/admin/assets/[id].vue")
  },
  {
    name: "admin-decks___en",
    path: "/admin/decks",
    meta: indexPNINfdJS6zqSj7OdilBfOrnaPr_WhB5BGrP0LeUs1KsMeta || {},
    component: () => import("/app/app/pages/admin/decks/index.vue")
  },
  {
    name: "admin-embeds-id___en",
    path: "/admin/embeds/:id()",
    meta: _91id_93yMh_dbsWq3U3H1mNnqNuA6L315ig1YUCvxRqAcKITd4Meta || {},
    component: () => import("/app/app/pages/admin/embeds/[id].vue")
  },
  {
    name: "admin-users___en",
    path: "/admin/users",
    meta: indexI6uA6JeAc9EKls3McO36wY7U9LUyjNGCD0Sfkr6BKwQMeta || {},
    component: () => import("/app/app/pages/admin/users/index.vue")
  },
  {
    name: "admin-assets___en",
    path: "/admin/assets",
    meta: indexsxhQDjaMms9Jr4S1DtAulDAQi2As4Pp7GkkR5v5SzsIMeta || {},
    component: () => import("/app/app/pages/admin/assets/index.vue")
  },
  {
    name: "admin-embeds___en",
    path: "/admin/embeds",
    meta: indexIECdWnrHSHMBuW3Zxz1A96Bgdyj05NRo2Z2K0soHhJwMeta || {},
    component: () => import("/app/app/pages/admin/embeds/index.vue")
  },
  {
    name: "admin-models___en",
    path: "/admin/models",
    meta: indexvOqUjCI6IynWruUOT_JjSNnkoInXY0r_YKXjStTSRGEMeta || {},
    component: () => import("/app/app/pages/admin/models/index.vue")
  },
  {
    name: "admin-companies-new___en",
    path: "/admin/companies/new",
    meta: newHV9Q5xSE2IPsPrvuoJ_JniwPXyqw3GWFYX4AH3vFM6UMeta || {},
    component: () => import("/app/app/pages/admin/companies/new.vue")
  },
  {
    name: "admin-embeds-create___en",
    path: "/admin/embeds/create",
    meta: createhSNsztH9__duTbHuA3S_iZuB7r3IckjZjOH0qhATBMAMeta || {},
    component: () => import("/app/app/pages/admin/embeds/create.vue")
  },
  {
    name: "beta-decks-deckId___en",
    path: "/beta/decks/:deckId()",
    meta: _91deckId_93sbkipH1lufvlYKfh0T0PeiGTgnFOWK6rn_7iL5qS7csMeta || {},
    component: () => import("/app/app/pages/beta/decks/[deckId].vue")
  },
  {
    name: "admin-companies___en",
    path: "/admin/companies",
    meta: indexdkwa9PpVT3S3S_MTH0YkNYrrCMxo_R1Xw9bqcGP1lq0Meta || {},
    component: () => import("/app/app/pages/admin/companies/index.vue")
  },
  {
    name: "admin-recordings-id___en",
    path: "/admin/recordings/:id()",
    meta: _91id_93fBeAP_VN8Fz7WLu9kWWl6L7_WsNhls_m1OQgmc5trjwMeta || {},
    component: () => import("/app/app/pages/admin/recordings/[id].vue")
  },
  {
    name: "admin-recordings___en",
    path: "/admin/recordings",
    meta: index8BKTnaioCF5YwJFvJmFyu9ZqI5owA32UhfcS18_ahrEMeta || {},
    component: () => import("/app/app/pages/admin/recordings/index.vue")
  },
  {
    name: "admin-embeds-video-id___en",
    path: "/admin/embeds/video/:id()",
    meta: _91id_93fWnjb1BIIQXyfTWBSlUitPeczwBoPfkZTCKAD2qI9f0Meta || {},
    component: () => import("/app/app/pages/admin/embeds/video/[id].vue")
  },
  {
    name: "admin-activate-token___en",
    path: "/admin/activate/:token?",
    component: () => import("/app/app/pages/admin/activate/[[token]].vue")
  },
  {
    name: "admin-embeds-video___en",
    path: "/admin/embeds/video",
    meta: indexhxrrYWKdxVL0tc_gyhxzQSts4QH85v4gr44_IfKXys8Meta || {},
    component: () => import("/app/app/pages/admin/embeds/video/index.vue")
  },
  {
    name: "admin-validate-slug___en",
    path: "/admin/validate/:slug(.*)*",
    meta: _91_46_46_46slug_936zR_bNvbWaovsjMg23rK6Lr9fbiiwEbq8DpLUac__0cMeta || {},
    component: () => import("/app/app/pages/admin/validate/[...slug].vue")
  },
  {
    name: "beta-meeting-meetingId___en",
    path: "/beta/meeting/:meetingId()",
    meta: _91meetingId_93tVWv9K0BEBPi1_yhcXnNFlDf_w6K8ga9HzHlRPvDdRIMeta || {},
    component: () => import("/app/app/pages/beta/meeting/[meetingId].vue")
  },
  {
    name: "embed-presentations-id___en",
    path: "/embed/presentations/:id()",
    meta: _91id_93quZpT3cfZEtaecpGilCykH18QQlabMxANnXbxchn4pgMeta || {},
    component: () => import("/app/app/pages/embed/presentations/[id].vue")
  },
  {
    name: "meetings-recordings-uuid___en",
    path: "/meetings/recordings/:uuid()",
    meta: _91uuid_93Z5HWRSUxJPOe6atzGj6z0eLMyhR0MXOcMzb7EGTrwiQMeta || {},
    component: () => import("/app/app/pages/meetings/recordings/[uuid].vue")
  },
  {
    name: "admin-feature-processing___en",
    path: "/admin/feature-processing",
    meta: index1ro0dzUl73NU10HiuYjvboRohl_XeronGVEnAChmYrcMeta || {},
    component: () => import("/app/app/pages/admin/feature-processing/index.vue")
  },
  {
    name: "admin-feature-processing-create___en",
    path: "/admin/feature-processing/create",
    meta: create9B9oxUxuhn2uZQ90lcksP0UQrfGB9nDlmT8ikUGkC9MMeta || {},
    component: () => import("/app/app/pages/admin/feature-processing/create.vue")
  },
  {
    name: "embed-presentations-preview-id___en",
    path: "/embed/presentations/preview/:id()",
    meta: _91id_93XlJyzI075nmFISzf4GGl_MevAfT_loD6yO20xkL8w0sMeta || {},
    component: () => import("/app/app/pages/embed/presentations/preview/[id].vue")
  }
]